import _ from 'lodash';
import {apiFetch, apiSearch} from '../utility';

const apiBase = 'quickbooksFreightAccount';
export const search = (p = {}) => {
	const { callback = _.noop } = p;
	return dispatch => {
		apiSearch({
			base : apiBase,
			params : {},
			dispatch,
			callback,
		});
	};
};

export const add = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.add`,
			listNameToUpdate : 'quickbooksFreightAccountIds',
			params,
			successMessage :
				`Quickbooks account successfully added to the available accounts
				for freight vendor billing`,
			dispatch,
			callback,
		});
	};
};